/// <amd-module name="VSSUI/Components/Observer/ItemsObserver" />
import * as React from "react";
import { IObservableArrayEventArgs, ObservableArrayAction } from "VSS/Core/Observable";
import { getItemsValue } from "VSSUI/Utilities/Provider";
import { IItemsObserverProps } from "./ItemsObserver.Props";
import { UncheckedObserver } from "./Observer";
import { IObservableExpression } from "./Observer.Props";

export class ItemsObserver<T> extends React.Component<IItemsObserverProps<T>> {
    public componentDidMount() {
        this.props.selection.unselectableRanges = this.props.getUnselectableRanges(getItemsValue(this.props.items));
    }

    public render() {
        const itemsObservable: IObservableExpression = {
            observableValue: this.props.items,
            filter: this.onItemsChanged
        };
        return <UncheckedObserver itemsObservable={itemsObservable}>{this.props.children}</UncheckedObserver>;
    }

    private onItemsChanged = (value: IObservableArrayEventArgs<T>, action: ObservableArrayAction) => {
        const { getUnselectableRanges, items, selection } = this.props;
        selection.onItemsChanged(value, action);
        selection.unselectableRanges = getUnselectableRanges(getItemsValue(items));
        return false;
    };
}
